import React from 'react';
import PropTypes from 'prop-types';

import { ContextProvider as ResourceNotesContextProvider } from 'components/ResourceNotes/Context';
import NewNote from 'components/ResourceNotes/Views/New/Index';
import NotesList from 'components/ResourceNotes/Views/List/Index';

export default function Index({ invoiceId }) {
  return (
    <ResourceNotesContextProvider resourceType="InvoiceCredit" resourceId={invoiceId}>
      <div className="ibox-content">
        <h2 className="block-title">
          Notes
        </h2>

        <NewNote />
        <NotesList />
      </div>
    </ResourceNotesContextProvider>
  );
}

Index.propTypes = {
  invoiceId: PropTypes.number.isRequired,
};
